// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"tf_a big_rc big_qx big_xr","ContestPosts__more":"tf_b big_vu big_b big_va big_sv"};